import Actions from '.';
import { get, deleteCall, patch,post } from '../../../utils/api';
import { API_ERROR_MESSAGE, USER_TYPES } from '../../../constants';

const getAgents = () => (async (dispatch, getState) => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/get-users?userType=${3}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response || [],
                nextPageToken: data.response && data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
            nextPageToken: null,
        }));
    }
});

const loadMoreAgents = () => (async (dispatch, getState) => {
    const { agents: { nextPageToken, list } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/agents/list?nextPageToken=${nextPageToken}`);
        if (data.statusCode === 200 && data.response && data.response.nextPageToken) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: [...list, ...data.response.agents],
                nextPageToken: data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});

const deleteAgent = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`user/${id}`);
        if (data.statusCode === 202) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getAgents());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const markAgent = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await patch(`user/agents/mark-as-agent/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getAgents());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const changeUserStatus = (body) => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await post(`/user/`,body);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getAgents());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const  updateFranchise = body => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    dispatch(Actions.updateProperty('success', false));

    try {
        const data = await post(`/user/`, body);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || 'User updated successfully',
                success: true,
                showFranchiseModal: false,

            }));
            dispatch(getAgents())
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
})

const getPurchaseHistory = (id) => (async (dispatch) => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/get-commissions?user_id=${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response || [],
                nextPageToken: data.response && data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
            nextPageToken: null,
        }));
    }
});

const loadPurchaseHistory = (id) => (async (dispatch, getState) => {
    const { agents: { nextPageToken, list } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`user/get-commissions?user_id=${id}&&nextPageToken=${nextPageToken}`);
        if (data.statusCode === 200 && data.response && data.response.nextPageToken) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: [...list, ...data.response.agents],
                nextPageToken: data.response.nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});



export default {
    getAgents,
    loadMoreAgents,
    deleteAgent,
    markAgent,
    changeUserStatus,
    updateFranchise,
    getPurchaseHistory,
    loadPurchaseHistory
}